export default __webpack_public_path__ + "static/media/~$rector, Customer and Patient experience.3d12e5dd.docx";